import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { fetchProjectNameComs } from "../../../actions/nameAction_Dwk";
import { openModal, closeModal } from "../../../actions/modalAction";
import { Segment, Icon, Input } from "semantic-ui-react";
import Confirm from "../../common/Confirm_1";
import { RiDeleteBin5Line } from "react-icons/ri";

class ProjectNameComList extends Component {
  state = {
    search: "",
    header: true,
    searchField: false,
    projectNameCom: "",
    open: false,
  };

  componentDidMount() {
    this.props.fetchProjectNameComs();
  }
  show = (val) => {
    this.setState({ open: true, projectNameCom: val });
  };

  handleConfirm = async () => {
    const values = { projectNameCom: this.state.projectNameCom };

    try {
      const res = await axios.post(`/api/dwk/ProjectNameComDelete`, values);

      if (res.data.msg === "success") {
        this.props.fetchProjectNameComs();
        this.setState({ open: false });
        toastr.success("Deleted Successfully");
      }
    } catch (error) {
      if (error.response.status == 401) {
        openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else {
        toastr.error("Oops", "Something went wrong.Please Try Again");
      }
    }
  };
  handleCancel = () => this.setState({ open: false });

  renderList = (item) => {
    const projectNameCom = item;

    const renderDeleteButton = () => (
      <span onClick={() => this.show(projectNameCom)} className="ml-05">
        <RiDeleteBin5Line
          className="icon-gr"
          style={{ backgroundColor: "red" }}
        />
      </span>
    );

    return (
      <div
        key={projectNameCom}
        style={{ paddingRight: "5px" }}
        className="card-attached mb-05 mt-05 py-05"
      >
        <div className="rowERP-snote">
          <div className="main flex-start display-linebreak flex-90">
            <b>{projectNameCom}</b>
          </div>
          <div className="side flex-end flex-10 px-05">
          {this.props.userA !== null && (this.props.userA.userType === 'admin' ||this.props.userA.userType === 'manager_dwk') && renderDeleteButton()}
          </div>
        </div>
      </div>
    );
  };
  //@@@@@@@@
  showSearchField = () => {
    this.setState({ header: false, searchField: true });
  };
  showHeader = () => {
    this.setState({ header: true, searchField: false, search: "" });
  };
  //^^^^^^^^^^^^^^^^^^^^^^^^^
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  //@@@@@@@

  //****************** */

  render() {
    const { open } = this.state;
    //@@@
    const { search } = this.state;
    const arrF = this.props.projectNameComs.filter((item) => {
      return item.toLowerCase().indexOf(search.toLowerCase()) !== -1;
    });
    //@@@
    //******************
    const renderHeaderOrSearch = () => {
      if (this.state.header === true) {
        return (
          <React.Fragment>
            <div className="cashbook-H">
              <div
                style={{
                  display: "flex",
                  flex: "10%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={this.props.closeModal}
              >
                <span className="back-btn">
                  <Icon name="arrow left" />
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  flex: "80%",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "1.3rem",
                    fontWeight: "bold",
                    padding: "5px",
                  }}
                >
                  {this.props.projectNameComs.length} Commercial Project Names
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flex: "10%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={this.showSearchField}
              >
                <span className="icon-button border1">
                  {" "}
                  <Icon name="search" />
                </span>
              </div>
            </div>
          </React.Fragment>
        );
      }
      if (this.state.searchField === true) {
        return (
          <React.Fragment>
            <Segment attached>
              <div className="disflex">
                {/**/}
                <div
                  style={{
                    display: "flex",
                    flex: "10%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={this.showHeader}
                >
                  <span onClick={this.showHeader} className="back-btn">
                    <Icon name="arrow left" />
                  </span>
                </div>

                {/**/}
                <div
                  style={{
                    display: "flex",
                    flex: "90%",
                    justifyContent: "center",
                  }}
                >
                  <Input
                    icon="search"
                    placeholder="Search..."
                    type="text"
                    name="search"
                    value={this.state.search}
                    onChange={this.onChange}
                  />
                </div>
              </div>
            </Segment>
          </React.Fragment>
        );
      }
    };
    //******************

    return (
      <div
        className="font-family-Roboto"
        style={{ maxWidth: "700px", margin: "auto" }}
      >
        <Confirm
          open={open}
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />

        {/**/}
        {renderHeaderOrSearch()}
        {/**/}

        {arrF.sort().map(this.renderList)}

        <br />
        <br />
      </div>
    );
  }
}

const mapStateToProps = ({ auth, dwk_name }) => {
  return {
    projectNameComs: dwk_name.projectNameComs,
    userA: auth.userA,
  };
};

export default connect(mapStateToProps, {
  fetchProjectNameComs,
  openModal,
  closeModal,
})(ProjectNameComList);
